import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles_m/tiles_m.css';
import '../styles/other.css';
import Axios from 'axios';
import { Link } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';

class AddGrantTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            grantBudget: 0,
            grantName: "",
            note: "",
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {


    }

    render() {
        return (
            <div className={"universalAddTile"} style={{position: "relative"}}>
                <span className="fontPoppinsSemiBold15 clickable">Add Grant</span>

                <div style={{position: "relative", backgroundColor: "var(--lightest-gray)", marginTop: 20}}>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Grant Name:*</span>
                        <input className="universalTextInput" type="text" style={{width: "100%", marginBottom: 5}} id="inputGrantName" name="inputGrantName" value={this.state.grantName} onChange={e => this.setState({ grantName: e.target.value })}/>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Grant Budget:*</span>
                        <input className="universalTextInput" type="number" style={{width: "100%", marginBottom: 5}} id="inputGrandBudget" name="inputGrantBudget" value={this.state.grantBudget} onChange={e => this.setState({ grantBudget: e.target.value })}/>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: -5}}>Note:*</span>
                        <textarea className="modalInputAddNote" rows="4" style={{backgroundColor: "white"}} placeholder="" id="textAreaNote" name="textAreaNote" value={this.state.note} onChange={e => this.setState({ note: e.target.value })}></textarea>
                    </div>

                    <div className="horizontalStack" style={{paddingLeft: 20, paddingTop: 10, paddingRight: 25, paddingBottom: 20}}>
                        <RoundButton title={"Add Grant"} className={"roundButtonOrange"} onClick={this.createNewAction} whiteText={true} />
                    </div>
                </div>

            </div>
        );
    }
}

export default AddGrantTile;
